export default __webpack_public_path__ + "static/B0281-74cc9335688e394e8a2b944af5cbc59d.png";